export default "__VITE_ASSET__53HeTaBe__"